import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { fetchProduct } from './sslAPI'

const initialState = {
	products: [],
	status: 'idle',
	error: '',
}

export const getProducts = createAsyncThunk(
	'productsSSL/getFromGID',
	async (gid, { rejectWithValue }) => {
		try {
			const response = await fetchProduct(gid)
			const data = await response.json()
			return data
		} catch (error) {
			return rejectWithValue(error.message)
		}
	}
)

const sslSlice = createSlice({
	name: 'ssl',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getProducts.pending, (state) => {
			state.status = 'loading'
		})
		builder.addCase(getProducts.fulfilled, (state, action) => {
			const { product } = action.payload.products
			state.status = 'idle'
			state.products = product
		})
		builder.addCase(getProducts.rejected, (state, action) => {
			state.status = 'idle'
			state.products = []
			state.error = action.error.message
		})
	},
})
export default sslSlice.reducer
